var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg168",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs172"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath182"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path180"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g174",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g178",
    clipPath: "url(#clipPath182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g184",
    transform: "translate(491.9902,256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.05,-21.046 -0.288,-42.093 -0.576,-63.138 -0.348,-25.391 -0.74,-50.793 -7.108,-75.749 -6.677,-26.17 -19.847,-48.74 -40.337,-65.449 -21.592,-17.608 -47.69,-26.863 -75.858,-28.576 -37.36,-2.272 -74.736,-3.17 -112.111,-3.082 -37.376,-0.088 -74.752,0.81 -112.111,3.082 -28.168,1.713 -54.266,10.968 -75.858,28.576 -20.49,16.709 -33.66,39.279 -40.338,65.449 -6.368,24.956 -6.76,50.358 -7.107,75.749 -0.288,21.045 -0.527,42.092 -0.576,63.138 0.049,21.046 0.288,42.093 0.576,63.138 0.347,25.391 0.739,50.793 7.107,75.749 6.678,26.17 19.848,48.74 40.338,65.449 21.592,17.608 47.69,26.863 75.858,28.576 37.359,2.272 74.735,3.17 112.111,3.082 37.375,0.088 74.751,-0.81 112.111,-3.082 28.168,-1.713 54.266,-10.968 75.858,-28.576 20.49,-16.709 33.66,-39.279 40.337,-65.449 6.368,-24.956 6.76,-50.358 7.108,-75.749 C -0.288,42.093 -0.05,21.046 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path186"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g188",
    transform: "translate(360,256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-57.99 -47.01,-105 -105,-105 -57.99,0 -105,47.01 -105,105 0,57.99 47.01,105 105,105 C -47.01,105 0,57.99 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path190"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g192",
    transform: "translate(424,391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-16.568 -13.432,-30 -30,-30 -16.568,0 -30,13.432 -30,30 0,16.568 13.432,30 30,30 C -13.432,30 0,16.568 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path194"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.dc12cd4bccc7c388035d3529caacd4b0.svg";
export { ForwardRef as ReactComponent };